// extracted by mini-css-extract-plugin
module.exports = {"relative":"Sort_relative__18Oue","sort_container":"Sort_sort_container__3W5c6","expanded":"Sort_expanded__3O_8y"};